<template>
  <div>
    <slot name="default"
          v-if="requestState === 'Success'"> <!-- default == Success -->
      Data loaded
    </slot>

    <slot name="NotPerformed"
          v-if="requestState === 'NotPerformed'">
      Data not loaded yet
    </slot>
    <slot name="Loading"
          v-if="requestState === 'Loading'">
      Loading
      <!-- todo(TECH-325): find pretty loader -->
    </slot>

    <slot name="Failed"
          v-if="requestState === 'Failed'">
      <div style="color: red">
        Can't perform request
      </div>
    </slot>
  </div>
</template>

<script>
    /**
     * Show different state for requested data
     * todo(egor): show error with details (x-tracer id + copy link if availiable)
     */
    export default {
        name: 'async-data',
        props: {
            requestState: {
                type: String, // RequestState
                required: true
            }
        },
        data() {
            return {}
        },
        computed: {},
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/AsyncData.vue